<template>
    <div class="flex flex-grow-1">
        <HugeSpinner class="mt6" v-if="loadingReceiptData"/>
        <HeadingContainer v-else :heading="'Rental: ' + listingData.title">

            <div class="row">
                <!-- rental options -->
                <div :class="{ 'col-xs-7 col-lg-8' : !xs, 'w-100' : xs }">
                    <RentalDetailsCard :listing="listingData" class="mt3 mb4-ns mt4-ns"/>
                </div>
                <!-- receipt -->
                <div class="mv3 mt4-ns" :class="{ 'col-xs-5 col-lg-4 flex-column' : !xs, 'w-100' : xs }">
                    <ReceiptCard/>
                </div>
            </div>
            <SingleButtonActionbar :enabled="checkInputs" @click="requestRentalClick" text="Request Rental" />
        </HeadingContainer>
    </div>
</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import RentalDetailsCard from '@/components/rent/rentalDetails/RentalDetailsCard.vue';
import ReceiptCard from '@/components/rent/rentalDetails/ReceiptCard.vue';
import SingleButtonActionbar from '@/components/global/SingleButtonActionbar.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

const TOOL = {
    title: 'Bostitch 3.5-in Cordless Framing Nailer'
};
export default {
    data() {
        return {
            tool: TOOL
        };
    },
    components: {
        HeadingContainer,
        RentalDetailsCard,
        ReceiptCard,
        SingleButtonActionbar,
        HugeSpinner
    },
    computed: {
        ...mapState('newRental', [
            'listingData',
            'loadingReceiptData',
            'userInput'
        ]),
        xs() {
            return this.$mq === 'xs';
        },
        checkInputs() {
            var input = this.userInput;

            var validAddress =
                this.userInput.location.address !== '' &&
                this.userInput.location.postalCode !== '' &&
                this.userInput.location.city !== '' &&
                this.userInput.location.province !== '';

            var validDates = input.startDate !== null && input.endDate !== null;

            var validDeliveryType = input.deliveryType !== null;

            return (
                this.userInput.deliveryType === 'renter_pickup' ||
                (validAddress && validDates && validDeliveryType)
            );
        }
    },
    methods: {
        ...mapActions('newRental', ['getReceiptData', 'postRental']),
        ...mapMutations('newRental', ['setDefaultDates', 'setListingId']),
        requestRentalClick() {
            this.postRental().then(() => {
                this.$router.push('/inbox');
            });
        }
    },
    created: function() {
        this.getReceiptData(this.$route.params.id);
        this.setDefaultDates();
        this.setListingId();
    }
};
</script>
